import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  headingStyle: {
    fontFamily: 'MANEurope, Arial, sans-serif',
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    color: '#303c49',
    lineHeight: 1.33
  }
})

const Heading6 = ({
  classes: { headingStyle },
  className,
  component,
  children,
  ...otherProps
}) => {
  const headingClass = classNames(headingStyle, className)
  return (
    <Typography
      component={component || 'h6'}
      className={headingClass}
      {...otherProps}
    >
      {children}
    </Typography>
  )
}

Heading6.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array
  ]),
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  children: PropTypes.node
}

export default withStyles(styles)(Heading6)



// WEBPACK FOOTER //
// ./src/styleguide/Heading6.js